import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from '../components/Header'
import BlogHeader from '../components/BlogHeader'

import favicon16 from '../images/favicon.png'

import '../../node_modules/bootstrap/dist/css/bootstrap.min.css'
import './index.css'

const TemplateWrapper = ({ children, location }) => {
  if (
    location.pathname.startsWith('/blog') ||
    location.pathname.startsWith('/abc')
  ) {
    return (
      <div>
        <Helmet
          title="Cornerstone Church Portsmouth"
          meta={[
            {
              name: 'description',
              content:
                'We are a church that wants to help people come to know Jesus more.',
            },
            {
              name: 'keywords',
              content: 'jesus, church, portsmouth, cornerstone, bible, life',
            },
          ]}
          link={[
            {
              rel: 'icon',
              type: 'image/png',
              sizes: '16x16',
              href: `${favicon16}`,
            },
          ]}
        />
        <BlogHeader />
        {children()}
      </div>
    )
  }
  return location.pathname !== '/christmascraft/' ? (
    <div>
      <Helmet
        title="Cornerstone Church Portsmouth"
        meta={[
          {
            name: 'description',
            content:
              'We are a church that wants to help people come to know Jesus more.',
          },
          {
            name: 'keywords',
            content: 'jesus, church, portsmouth, cornerstone, bible, life',
          },
        ]}
        link={[
          {
            rel: 'icon',
            type: 'image/png',
            sizes: '16x16',
            href: `${favicon16}`,
          },
        ]}
      />

      {children()}

      <section>
        <div className="container" style={{ paddingTop: 0 }}>
          <div className="row">
            <p style={{ fontSize: '16px', textAlign: 'center' }}>
              Cornerstone Church Portsmouth CIO is a registered charity,
              no.1178431
            </p>
          </div>
        </div>
      </section>
    </div>
  ) : (
    children()
  )
}

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js